import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';
import Navbar from '../components/layout/Navbar';
import { motion } from 'framer-motion';
import { useToast } from '../components/ui/Toast';

const Dashboard = () => {
    const navigate = useNavigate();
    const [pipelines, setPipelines] = useState([]);
    const [loading, setLoading] = useState(true);
    const { toast } = useToast();

    useEffect(() => {
        fetchPipelines();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchPipelines = async () => {
        try {
            const res = await client.get('/pipelines/');
            setPipelines(res.data);
        } catch (err) {
            console.error(err);
            toast.error('Failed to load pipelines. Please refresh the page.', { title: 'Loading Error' });
        } finally {
            setLoading(false);
        }
    };

    const handleCreateNew = () => {
        // In a real app we might create a draft in DB first, but here we just go to editor
        // We'll treat 'new' as a route param or just empty state
        navigate('/pipeline/new');
    };

    return (
        <div className="min-h-screen bg-cyber-black font-rajdhani">
            <Navbar />
            <div className="pt-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center mb-10">
                    <h1 className="text-3xl font-bold text-white font-orbitron">Your Pipelines</h1>
                    <button
                        onClick={handleCreateNew}
                        className="px-6 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold shadow-[0_0_15px_rgba(99,102,241,0.4)] transition-all hover:scale-[1.02] border border-transparent font-orbitron tracking-wide"
                    >
                        + Create Pipeline
                    </button>
                </div>

                {loading ? (
                    <div className="text-center text-gray-500 py-20 font-mono">Loading protocols...</div>
                ) : pipelines.length === 0 ? (
                    <div className="text-center py-20 border-2 border-dashed border-gray-800 rounded-2xl bg-cyber-gray/50">
                        <p className="text-xl text-gray-400 mb-4">No pipelines found.</p>
                        <button onClick={handleCreateNew} className="text-neon-blue font-medium hover:underline hover:text-neon-purple transition-colors">
                            Create your first one
                        </button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {pipelines.map((pipeline) => (
                            <motion.div
                                key={pipeline._id || pipeline.id}
                                layoutId={pipeline._id}
                                className="bg-cyber-gray p-6 rounded-xl shadow-[0_0_10px_rgba(0,0,0,0.5)] hover:shadow-[0_0_20px_rgba(0,243,255,0.2)] transition-all border border-gray-800 hover:border-neon-blue cursor-pointer group"
                                onClick={() => navigate(`/pipeline/${pipeline._id || pipeline.id}`)}
                            >
                                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-neon-blue transition-colors font-orbitron tracking-wide">
                                    {pipeline.title || "Untitled Pipeline"}
                                </h3>
                                <p className="text-gray-400 text-sm mb-4 font-mono">
                                    {pipeline.nodes?.length || 0} nodes • {pipeline.edges?.length || 0} edges
                                </p>
                                <div className="flex justify-between items-center mt-4">
                                    <span className="text-xs text-neon-blue bg-neon-blue/10 border border-neon-blue/30 px-2 py-1 rounded font-mono">
                                        Active
                                    </span>
                                    <span className="text-neon-blue text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                                        Access &rarr;
                                    </span>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;
